import { createFileRoute, stripSearchParams, useNavigate } from '@tanstack/react-router'
import { useCallback } from 'react'

import { PaymentReconciliationPage } from '@/components/Business/PaymentReconciliationPage'
import {
  EMPTY_RECONCILIATION_SEARCH,
  type ReconciliationSearch,
  reconciliationSearchSchema,
  withoutReconciliationDefaults,
} from '@/components/Business/reconciliationSearch'

/** Wiring only. The schema lives beside the page in `reconciliationSearch.ts`. */
export const Route = createFileRoute('/_app/business/payment-reconciliation')({
  validateSearch: reconciliationSearchSchema,
  search: { middlewares: [stripSearchParams(EMPTY_RECONCILIATION_SEARCH)] },
  component: PaymentReconciliationRoute,
})

function PaymentReconciliationRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  const onSearchChange = useCallback(
    (next: Partial<ReconciliationSearch>) =>
      void navigate({
        search: (current) => withoutReconciliationDefaults({ ...current, ...next }),
        replace: true,
        resetScroll: false,
      }),
    [navigate],
  )
  return <PaymentReconciliationPage search={search} onSearchChange={onSearchChange} />
}
